import { Secret } from "../models/secret";
import { CustomerPortalToken } from "./checkTokenCustomerInvite";
import { createTokenCustomerPortalToPathname } from "./createTokenCustomerPortalToPathname";

interface History {
  replace: (path: string) => void;
}

export const setWindowLocationWithTokenCustomerPortal = (
  history: History,
  customerPortalToken: CustomerPortalToken,
  secret?: Secret
) => {
  if (secret && secret?.SECRET_KEY_PASSWORD) {
    const token = createTokenCustomerPortalToPathname(
      customerPortalToken,
      secret?.SECRET_KEY_PASSWORD
    );

    if (token) {
      history.replace(`/jobs/${token}`);
    }
  }
};
